import type { Unit } from "./events.ts";

/**
 * How far along a task is, as words. Written once here because the terminal
 * and the page both show it.
 */
export function formatAmount(done: number, total: number | undefined, unit: Unit | undefined): string {
    // A task that has a unit but no total and no position has nothing to say
    // yet: a build says "0 steps" for as long as it is configuring otherwise.
    if (total === undefined && done === 0) return "";
    if (unit === undefined && total === undefined) return String(done);
    if (unit === "bytes") {
        // Both numbers in the unit the larger one asks for, so that a position
        // and its total read as a pair and neither changes unit as it grows.
        const scale = scaleOf(total ?? done);
        return total === undefined ? size(done, scale) : `${size(done, scale)} of ${size(total, scale)}`;
    }
    const counts = total === undefined ? String(done) : `${done} of ${total}`;
    return unit === undefined ? counts : `${counts} ${unit}`;
}

interface Scale {
    by: number;
    digits: number;
    name: string;
}

/**
 * What to count bytes in. An asset set is megabytes and a flash image is
 * kilobytes, and "0.0 MB of 0.0 MB" is no answer at all.
 */
function scaleOf(bytes: number): Scale {
    if (bytes >= 1024 * 1024) return { by: 1024 * 1024, digits: 1, name: "MB" };
    if (bytes >= 1024) return { by: 1024, digits: 0, name: "KB" };
    return { by: 1, digits: 0, name: "B" };
}

function size(bytes: number, scale: Scale): string {
    return `${(bytes / scale.by).toFixed(scale.digits)} ${scale.name}`;
}
